<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:header)
      bf-header(title='Contacts')
    #contacts.view
</template>

<script>
  import { View } from '@/mixins/view'
  
  export default {
    name: 'view.contacts',
    
    mixins: [View]
  }

</script>
